module.exports = __webpack_public_path__ + "static/media/baner-tip-icon.bbd8eeea.svg";